
"use client"

import { Button, Col, InputNumber, Row } from "antd"

import Title from "@/components/common/Typography/Title"
import Text from "@/components/common/Typography/Text"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useState } from "react"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { useHotelSearchUrlSync } from "@/hooks/hotel/useHotelSearchUrlSync"
import { useTranslation } from "react-i18next"

const InputAdult = () => {
  const value = useAppSelector(state => state.hotel.formSearch.adults || 0)
  const roomsNum = useAppSelector(state => state.hotel.formSearch.roomsNum || 1)
  const isDesktop = useIsDesktop()
  const dispatch = useAppDispatch()
  const syncHotelSearchUrl = useHotelSearchUrlSync()
  const { t } = useTranslation()

  const setValue = (val: any) => {
    dispatch(hotelActions.updateAdults(val))
    syncHotelSearchUrl()
  }
  return (
    <Row gutter={[50, 10]} style={{ marginBlock: '1.6rem' }} justify='space-between' align='middle'>
      <Col>
        <Row>
          <Title level={isDesktop ? 4 : 5} style={{ margin: 0 }}>{t("common.adult")}</Title>
        </Row>
        <Row>
          <Text type='secondary'>{t("common.adult_rule", { min: 18 })}</Text>
        </Row>
      </Col>
      <Col>
        <Row align='middle' gutter={[5, 5]}>
          <Col>
            <Button disabled={value <= roomsNum} onClick={() => setValue(value - 1)} size='large' shape='circle' icon={<MinusOutlined />} />
          </Col>
          <Col>
            <InputNumber
              min={roomsNum}
              onChange={(v) => setValue(v || roomsNum)}
              value={value} variant='borderless'
              controls={false} size='large'
              style={{ maxWidth: 45 }}
            />
          </Col>
          <Col>
            <Button onClick={() => setValue(value + 1)} size='large' shape='circle' icon={<PlusOutlined />} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default InputAdult